import {AddressModel} from './Address.model';
import {ContactModel} from './Contact.model';

export class AddressWithContactModel {
  public address?: AddressModel;
  public contact?: ContactModel;
  public addressId?: string;

  constructor(addressWithContact: AddressWithContactModel) {
    this.address = addressWithContact.address;
    this.contact = addressWithContact.contact;
    this.addressId = addressWithContact?.addressId;
  }
}
